<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="name" placeholder="请输入站点名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="certificateBatchId" clearable placeholder="请选择证书批次" @change="getSiteList">
                        <el-option v-for="item in batchList" :key="item.id" :label="item.batchName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="auditStatus" clearable placeholder="请选择审核状态" @change="getSiteList">
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="审核通过(未颁证)" :value="1"></el-option>
                        <el-option label="审核未通过" :value="2"></el-option>
                        <el-option label="审核通过(已申请纸质证书)" :value="3"></el-option>
                        <el-option label="审核通过切颁证" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getSiteList()">搜索</el-button>
                    <!-- <a class="export-button-a" style="color:#fff;margin-left:10px;" :href="exportExam">导出</a> -->
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list" ref="multipleeeeTable">
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="schoolName" label="站点名称"></el-table-column>
                <el-table-column prop="siteUserName" label="考务账号"></el-table-column>
                <el-table-column prop="examinationPhone" label="联系手机号"></el-table-column>
                <!-- <el-table-column prop="itcCertificateNum" label="itc证书申请总数"></el-table-column> -->
                <el-table-column prop="certificateCount" label="申请证书数量"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="toItcManager(scope.row.id)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="u-page-con">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    v-show="totalCount > 0"
                    style="text-align: center"
                ></el-pagination>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            name: "",
            idCard: "",
            certificateNumber: "",
            certificateType: "",
            certificateBatchId: "",
            auditStatus:"",
            list: [],
            from: {
                id: "",
                name: "",
                unitName: "",
                idType: "",
                idCard: "",
                studentPinYin: "",
                studentUrl: "",
                certificateNumber: "",
                certificateName:"",
                certificateType: "",
                certificateBatchId: "",
                certificateLevel:"",
                certificateIssueDate:""
            },
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            titleFormVisible: "",
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            // uploadUrl: "/api/XOrg/ItcCertificateMag/uploadExcelPro",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: "",
            batchList: [],
            searCertGradeList: [],
            // 导入结果
            inportcertificateBatchId:"",
            dataResultVisible: false,
            wordUrl: "/public/docs/ITC证书信息导入模板.xlsx",
            count: 0,
            successNum: 0,
            successFileName: "",
            failNum: 0,
            failFileName: "",
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            //
            percentageVisible: false,
            percentage: 0,
            taskId: "",
            timer: null,
            ids: [],
            importRule: {
                inportcertificateBatchId: [
                    { required: true, message: '请选择证书批次', trigger: 'blur' }
                ]
            },
            // 头像上传
            touXiangDialog: false,
            TisiDialog: false,
            tisiList: [],
            // 获取row的key值
            getRowKeys(row) {
                return row.id;
            }
        };
    },
    components: {
    },
    computed: {
        exportExam: function() {
            return (
                "/api/XOrg/ItcCertificateMag/exportItcExcel?name=" +
                this.name +
                "&idCard=" +
                this.idCard +
                "&certificateNumber=" +
                this.certificateNumber +
                "&certificateType=" +
                this.certificateType +
                "&certificateBatchId=" +
                this.certificateBatchId
            );
        }
    },
    created() {
        this.getSessionStorage();
        this.getSiteList();
        this.getItcBatchList();
    },
    watch: {
    },
    methods: {
        getItcBatchList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateBatch/getItcBatchList", {
                    type: 0,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.batchList = rst.batchList;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //查询
        getSiteList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateSysMag/getSiteList", {
                    name: this.name,
                    batchId:this.certificateBatchId,
                    auditStatus:this.auditStatus,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;

                        sessionStorage.setItem("itcSiteManager_certificateBatchId",that.certificateBatchId);
                        sessionStorage.setItem("itcSiteManager_auditStatus",that.auditStatus);

                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        // 获取网页缓存信息
        getSessionStorage(){
            // 获取网页缓存信息
            var certificateBatchId = sessionStorage.getItem("itcSiteManager_certificateBatchId");
            var auditStatus = sessionStorage.getItem("itcSiteManager_auditStatus");
            
            if(certificateBatchId != null&& certificateBatchId != undefined&&certificateBatchId!="null"){
                this.certificateBatchId = certificateBatchId;
            }
            if(auditStatus != null&& auditStatus != undefined&&auditStatus!="null"){
                this.auditStatus = auditStatus!=""? Number(auditStatus):"";
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSiteList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getSiteList();
        },
        toItcManager(schoolId){
            this.$router.push({
                name: "itcManager",
                params: {
                    schoolId: schoolId,
                },
            });
        }
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
    .export-button-a{
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
